import { render, staticRenderFns } from "./MatchTech.vue?vue&type=template&id=411e5e84"
import script from "./MatchTech.vue?vue&type=script&lang=js"
export * from "./MatchTech.vue?vue&type=script&lang=js"
import style0 from "./MatchTech.vue?vue&type=style&index=0&id=411e5e84&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports